// Simple user mapping for single family use
// This replaces the complex Users collection lookup

// Map of display names to Firebase Auth UIDs
// TODO: Replace these placeholder UIDs with your actual Firebase Auth UIDs
// You can find these by logging authUser.uid in your app when each person is signed in
export const USER_MAPPING = {
  Ryan: "CvWOX0v1C4QBN2oHdLCZoNGnuVf2", // Replace with actual UID from Firebase Auth
  Leah: "YKWCl65I5NOt7dL2UOI9DTAMGPL2", // Replace with actual UID from Firebase Auth
  Samantha: "CzcExYjxGyepLSWtUXS1R5Je4Vg2",
  Connor: "YzZT4pjCriY4e9tDdNDFTRQfw3D3",
  Marie: "atsUGC3KbIgogCVdWmMvoPaABr02",
  // Add other family members as needed
  // "Child1": "REPLACE_WITH_CHILD1_FIREBASE_UID",
}

// Get Firebase UID from assignee name
export const getFirebaseUidFromName = (name) => {
  const uid = USER_MAPPING[name]
  if (!uid || uid.startsWith("REPLACE_WITH_")) {
    return null
  }
  return uid
}

// Get display name from Firebase UID
export const getNameFromFirebaseUid = (uid) => {
  return (
    Object.keys(USER_MAPPING).find((name) => USER_MAPPING[name] === uid) || null
  )
}

// List of all family member names
export const FAMILY_MEMBERS = Object.keys(USER_MAPPING)

// Check if a name is a valid family member
export const isValidFamilyMember = (name) => {
  return FAMILY_MEMBERS.includes(name)
}
